import { newAttemptId, reportWorkflow } from "../../observability/telemetry.js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { isAggregatorPortalHost, readSelectedAggregatorGrower } from "../../portal/aggregatorGrowerContext.js";

const interactionCodes = new Set([
  "interaction_required", "login_required", "consent_required", "no_account_error",
]);
const networkCodes = new Set([
  "no_network_connectivity", "network_error", "get_request_failed", "post_request_failed",
]);

export function sessionAccountKey(account) {
  if (!account) return "";
  return JSON.stringify([
    account.homeAccountId || account.localAccountId || "",
    account.tenantId || account.idTokenClaims?.tid || "",
    account.environment || "",
  ]);
}

export function selectedGrowerContextKey(account) {
  return isAggregatorPortalHost(window.location.hostname, process.env, account)
    ? readSelectedAggregatorGrower()?.grower_profile_public_id || null : null;
}

export function classifySessionError(error) {
  if (error?.errorCode === "session_context_changed") return "context_changed";
  if (error instanceof InteractionRequiredAuthError || error?.name === "InteractionRequiredAuthError" || interactionCodes.has(error?.errorCode) || interactionCodes.has(error?.subError)) return "interaction_required";
  if (typeof navigator !== "undefined" && navigator.onLine === false) return "offline";
  if (networkCodes.has(error?.errorCode)) return "network_unavailable";
  if (error?.errorCode === "user_cancelled" || error?.errorCode === "popup_window_error") return "interaction_cancelled";
  if (error?.response?.status === 403) return "access_denied";
  if (error?.response?.status === 401) return "interaction_required";
  return "retry_required";
}

export function sessionContextChanged() {
  const error = new Error("The account or workspace changed. Retry in the current workspace.");
  error.errorCode = "session_context_changed";
  return error;
}

export function announceSessionIssue(error, { stage = "silent_token", lane = "unknown", requestId, attemptId = newAttemptId() } = {}) {
  const reason = classifySessionError(error);
  if (reason === "context_changed") return reason;
  window.dispatchEvent(new CustomEvent("fieldprint:session-expired", { detail: { reason } }));
  reportWorkflow({
    workflow: "auth", outcome: reason === "interaction_cancelled" ? "cancelled" : "failed",
    reason: "auth_recovery_failed", attemptId, auth_stage: stage, auth_reason: reason, auth_lane: lane,
    requestId: requestId || error?.response?.headers?.["x-request-id"] || error?.config?._ftmcTelemetry?.requestId,
    correlation_id: error?.correlationId,
  });
  return reason;
}
